import styled from 'styled-components';

export default styled.h4`
  margin-bottom: 1rem;
  line-height: 1.1;
  font-weight: bold;
  color: #ff3600;
`;
